import { Suspense, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { Loader } from "./Components/UI";
import { PrivacyPolicy, Referral } from "./Pages";
import store, { persistor } from "./Redux/Store";
import { versionManager } from "./Services/common.service";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Referral />,
  },

  // {
  //   path: "/referral",
  //   element: <Referral />,
  // },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
]);

function App() {
  useEffect(() => {
    const initialize = async () => {
      await versionManager();
    };
    initialize();
  }, []);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Toaster position="top-right" />
        <Loader />
        <Suspense
          fallback={
            <>
              <Loader />
            </>
          }
        >
          <RouterProvider router={router} />
        </Suspense>
      </PersistGate>
    </Provider>
  );
}

export default App;
